import React, { useState, useEffect } from 'react'
import get from 'lodash/get'
import Link from 'next/link'
import fetch from 'lib/decorated-fetch'
import classnames from 'classnames'
import { sendTeaCommEvent } from 'lib/tea-analyze'
import { getZT } from 'lib/zt-util'
import getUrl from 'lib/url'
import getLinkHref from 'lib/get-link-href'

import Button from 'Components/button'
import { useCityName } from 'Components/hooks'

import Tab from './common/tab'
import { ICar, IAction } from './store'
import getQuery from '@arsenal/arsenal/modules/getQuery'

const hoverIcon = require('static/hover-icon.png')
const hoverIcon2 = require('static/hover-icon@2x.png')
const hoverIcon3 = require('static/hover-icon@3x.png')
interface IOnline {
  type: string
  info: {
    name: string
    dealer_price: string
    price: string
    id: number
    year: number
    car_id: number
  }
}

interface ICarItem {
  type: '1037'
  info: {
    name: string
    price: string
    id: number
    year: number
    car_id: number
    dealer_price: string
    owner_price_summary: {
      naked_price_avg: string
      price_num: number
    }
  }
}
interface ITitle {
  type: '1036'
  info: {
    name: string
  }
}
type IOption = ICarItem | ITitle
interface IProps {
  seriesId: number
  seriesName: string
  pkCars: ICar[]
  dispatch: React.Dispatch<IAction>
}

interface IYear {
  [year: string]: IOption[]
}
interface IData {
  years: string[]
  yearsList: IYear | null
}

function hanldeOnlineData(data: IOption[], years: number[]): IYear {
  return years.reduce((acc: IYear, year) => {
    const filted = data.filter(item => {
      if (item.type === '1036') {
        return true
      }
      if (item.type === '1037') {
        return item.info.year === year
      }
      return false
    })
    acc[`${year}款`] = filted.filter((item, index) => {
      // 过滤连续两个1036的情况，这里可以改写成reduce
      const next = filted[index + 1]
      if (item.type === '1036' && (!next || next.type === '1036')) {
        return false
      }
      return true
    })
    return acc
  }, {})
}

export default function CarModels({
  pkCars,
  dispatch,
  seriesId,
  seriesName,
}: IProps) {
  const [curIndex, setCurIndex] = useState(0)
  const [data, setData] = useState<IData>({
    years: [],
    yearsList: null,
  })
  const [fold, setFold] = useState(true)
  const cityName = useCityName()
  useEffect(() => {
    if (typeof cityName === 'undefined') {
      return
    }
    // show_city_price=1 根据城市名出报价，不加此参数默认为全国最低价
    fetch(
      getUrl(
        `/motor/car_page/m/v1/series_all_json/?series_id=${seriesId}&city_name=${encodeURIComponent(
          cityName
        )}&show_city_price=1&m_station_dealer_price_v=1`
      )
    )
      .then(json => {
        const online = get(json, 'data.online', []) as IOption[]
        const offline = get(json, 'data.offline', []) as IOption[]
        const urban = get(json, 'data.urban', []) as IOption[]
        const years = online
          .filter(item => item.type === '1037')
          .map(item => (item as ICarItem).info.year)
        const yearsText = Array.from(new Set(years))
          .sort((a, b) => b - a)
          .map(item => `${item}款`)

        const yearsList = hanldeOnlineData(online, years)
        if (offline.length) {
          yearsText.push('停售')
          yearsList['停售'] = offline
        }
        if (urban.length) {
          yearsText.push('未售')
          yearsList['未售'] = urban
        }
        // setList([...online, [offline]])
        setData({
          years: yearsText,
          yearsList,
        })
        // 支持定位
        if (yearsText?.length && getQuery('anchorId') === 'carModels') {
          setTimeout(() => {
            const element = document?.querySelector(`#carModels`) as HTMLElement
            if (element?.offsetTop) {
              window.scrollTo(0, element?.offsetTop - 80)
            }
          }, 100)
        }
      })
      .catch(err => {
        // no-op
      })
  }, [cityName, seriesId])
  let yearData = null
  if (data.years.length && data.yearsList) {
    yearData = data.yearsList[data.years[curIndex]]
  }
  function renderCar(list: IOption[]) {
    const len = list.length
    if (!len) {
      return null
    }
    const newList: IOption[] = []
    list.forEach(item => {
      if (newList.filter(item => item.type === '1037').length < 6) {
        newList.push(item)
      }
    })
    const showList = fold ? newList : list
    return (
      <div>
        {showList.map((data, index) => {
          const isTitle = data.type === '1036'
          const isPkButtonDisable = pkCars.some(
            item => item.carId === (data as ICarItem).info.car_id
          )
          return (
            <div
              className={classnames('clearfix', {
                'title-box': isTitle,
                box: !isTitle,
              })}
              key={data.info.name}
            >
              {isTitle ? <div className="mark fl" /> : null}

              {/*<div className="fl line-1 name" title={data.info.name}>*/}
              {/*  {isTitle ? (*/}
              {/*    <span className="title">{data.info.name}</span>*/}
              {/*  ) : (*/}
              {/*    data.info.name*/}
              {/*  )}*/}
              {/*</div>*/}

              <div className="fl" title={data.info.name}>
                {isTitle ? (
                  <span className="title line-1">{data.info.name}</span>
                ) : (
                  <div className="sub_title line-1">{data.info.name}</div>
                )}
              </div>

              <div
                className={classnames('fl', {
                  price: isTitle,
                  price_number: !isTitle,
                })}
              >
                {isTitle ? '指导价' : (data as ICarItem).info.price}
              </div>
              <div
                className={classnames('dealer_price  fl', {
                  dealer: !isTitle,
                })}
              >
                {isTitle ? (
                  <React.Fragment>
                    <span>
                      经销商报价
                      <img
                        src={hoverIcon}
                        srcSet={`${hoverIcon2}, ${hoverIcon3}`}
                        alt="avatar"
                        className="avatar"
                      />
                    </span>
                    <div className="title_tip">
                      <div className="title_tip_content">
                        经销商报价为车辆裸车最低价，不同商家优惠金额与方式不同，部分商家优惠会搭配优惠条件
                      </div>
                      <div className="title_tip_triangle" />
                    </div>
                  </React.Fragment>
                ) : (data as ICarItem).info.dealer_price ? (
                  <Link
                    href={`/dealer?seriesId=${seriesId}&carId=${
                      (data as ICarItem).info.car_id
                    }&zt=${getZT('pc_series_car_list')}`}
                    as={getLinkHref(
                      `/dealer/${seriesId}?carId=${
                        (data as ICarItem).info.car_id
                      }&zt=${getZT('pc_series_car_list')}`
                    )}
                  >
                    <a target="_blank">
                      <span className="price-line">
                        {(data as ICarItem).info.dealer_price}
                      </span>
                      <Button
                        type="new_primary"
                        className={`dealer-btn button-price`}
                        onClick={() => {
                          sendTeaCommEvent('click_style_button', {
                            car_series_id: seriesId,
                            car_style_id: (data as ICarItem).info.car_id,
                            button_text: '询底价',
                            sub_tab: String((data as ICarItem).info.year),
                          })
                        }}
                      >
                        询底价
                      </Button>
                    </a>
                  </Link>
                ) : (
                  <span>暂无报价</span>
                )}
              </div>
              <div className="fl final-price">
                {isTitle ? (
                  <div className="final-price-title">
                    <React.Fragment>
                      <span>
                        车主参考价
                        <img
                          src={hoverIcon}
                          srcSet={`${hoverIcon2}, ${hoverIcon3}`}
                          alt="avatar"
                          className="avatar"
                        />
                      </span>
                      <div className="title_tip">
                        <div className="title_tip_content">
                          车主参考价为近6个月所有车主购买裸车价的平均值，优先展示本地价格平均值，若无本地则展示全国价格平均值
                        </div>
                        <div className="title_tip_triangle" />
                      </div>
                    </React.Fragment>
                    {/* <div className="title-icon">真实</div> */}
                  </div>
                ) : /* eslint-disable indent */
                (data as ICarItem).info.owner_price_summary ? (
                  <div
                    className="final-price-number"
                    onMouseEnter={() => {
                      sendTeaCommEvent('show_series_page_owner_price_hover', {
                        car_series_name: seriesName,
                        car_series_id: seriesId,
                        series_module_name: '全部车型',
                        car_style_id: (data as ICarItem).info.car_id,
                        car_style_name: (data as ICarItem).info.name,
                      })
                    }}
                  >
                    <span>
                      {
                        (data as ICarItem).info.owner_price_summary
                          .naked_price_avg
                      }
                      万
                      <div className="tip">
                        <div className="tip-top">
                          <div className="tip-title">
                            共
                            <span>
                              {
                                (data as ICarItem).info.owner_price_summary
                                  .price_num
                              }
                              条
                            </span>
                            条车主参考价
                          </div>
                          <span>解锁更多车主参考价，扫码下载懂车帝App</span>
                        </div>
                        <div className="tip-bottom">
                          <div className="tip-bottom-left" />
                          <div className="tip-bottom-right" />
                        </div>
                        <div className="triangle" />
                      </div>
                      <div className="tip">
                        <div className="tip-top">
                          <div className="tip-title">
                            共
                            <span>
                              {
                                (data as ICarItem).info.owner_price_summary
                                  .price_num
                              }
                              条
                            </span>
                            条车主参考价
                          </div>
                          <span>解锁更多车主参考价，扫码下载懂车帝App</span>
                        </div>
                        <div className="tip-bottom">
                          <div className="tip-bottom-left" />
                          <div className="tip-bottom-right" />
                        </div>
                        <div className="triangle" />
                      </div>
                    </span>
                  </div>
                ) : (
                  <span>暂无</span>
                )}
              </div>
              <div className="fl buttons">
                {isTitle ? (
                  '车型详情'
                ) : (
                  <React.Fragment>
                    <Link
                      href={`/auto/params?carIds=${
                        (data as ICarItem).info.car_id
                      }`}
                      as={getLinkHref(
                        `/auto/params?carIds=${(data as ICarItem).info.car_id}`
                      )}
                    >
                      <a target="_blank">
                        <Button
                          className={`button button-config`}
                          onClick={() => {
                            sendTeaCommEvent('click_style_button', {
                              car_series_id: seriesId,
                              car_style_id: (data as ICarItem).info.car_id,
                              button_text: '参数',
                              sub_tab: String((data as ICarItem).info.year),
                            })
                          }}
                        >
                          配置
                        </Button>
                      </a>
                    </Link>
                    <Link
                      href={`/auto/images/list?seriesId=${seriesId}&carId=${
                        (data as ICarItem).info.car_id
                      }&carName=${data.info.name}`}
                      as={getLinkHref(
                        `/auto/series/${seriesId}/images?carId=${
                          (data as ICarItem).info.car_id
                        }&carName=${data.info.name}`
                      )}
                    >
                      <a target="_blank">
                        <Button
                          className={`button button-config`}
                          onClick={() => {
                            sendTeaCommEvent('click_style_button', {
                              car_series_id: seriesId,
                              car_style_id: (data as ICarItem).info.car_id,
                              button_text: '图片',
                              sub_tab: String((data as ICarItem).info.year),
                            })
                          }}
                        >
                          图片
                        </Button>
                      </a>
                    </Link>
                    <Button
                      disabled={isPkButtonDisable}
                      onClick={e => {
                        e.stopPropagation()
                        e.nativeEvent.stopImmediatePropagation()
                        dispatch({
                          type: 'togglePk',
                          payload: true,
                        })
                        dispatch({
                          type: 'addCar',
                          payload: {
                            carId: (data as ICarItem).info.car_id,
                            carName: data.info.name,
                          },
                        })
                        sendTeaCommEvent('click_style_button', {
                          car_series_id: seriesId,
                          car_style_id: (data as ICarItem).info.car_id,
                          button_text: isPkButtonDisable ? '已对比' : '对比',
                          sub_tab: String((data as ICarItem).info.year),
                        })
                      }}
                      className={`button button-config`}
                    >
                      {isPkButtonDisable ? '已对比' : '对比'}
                    </Button>
                  </React.Fragment>
                )}
              </div>
            </div>
          )
        })}
        <style jsx>
          {`
            .avatar {
              display: inline-block;
              margin-left: 2px;
              width: 10px;
              height: 10px;
              border: solid 0.5px #e6e8f2;
              cursor: pointer;
              vertical-align: middle;
              border-radius: 50%;
            }

            .mark {
              margin-top: 6px;
              margin-right: 12px;
              width: 4px;
              height: 10px;
              background-color: #ffcc32;
            }
            .price-line {
              display: inline-block;
              font-size: 14px;
              font-weight: 500;
              color: #1f2129;
            }
            .price-line:hover {
              text-decoration: underline;
            }
            .fold {
              height: 313px;
              overflow: hidden;
            }
            .title {
              display: inline-block;
              width: 275px;
              padding-right: 12px;
              color: #1f2129;
              font-size: 14px;
              font-weight: 500;
            }

            .sub_title {
              width: 291px;
              padding-left: 16px;
              padding-right: 12px;
              color: #1f2129;
              font-size: 14px;
            }
            .dealer_price {
              position: relative;
              font-size: 14px;
              color: #1f2129;
              width: 164px !important;
            }
            .dealer_price:hover .title_tip {
              display: block;
            }
            .title_tip {
              display: none;
              position: absolute;
              bottom: 26px;
              left: -80px;
              width: 280px;
              z-index: 1;
              padding: 12px 16px;
              background: rgba(0, 0, 0, 0.72);
              border-radius: 4px;
              box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.2);
            }
            .title_tip_content {
              font-size: 14px;
              color: #ffffff;
              letter-spacing: 0;
              line-height: 20px;
              font-weight: 400;
            }
            .title_tip_triangle {
              width: 0;
              height: 0;
              position: absolute;
              bottom: -6px;
              left: 150px;
              border-width: 6px;
              border-style: solid;
              border-color: rgba(0, 0, 0, 0.72) rgba(0, 0, 0, 0.72) transparent
                transparent;
              transform: rotate(135deg);
            }
            .box {
              margin: 0 16px;
              font-size: 16px;
              line-height: 68px;
              box-shadow: 0 1px 0 0 #f2f4fa;
            }
            .box:last-child {
              box-shadow: 0 0 0 0 #f2f4fa;
            }
            .title-box {
              width: 836px;
              height: 36px;
              padding: 8px 0;
              border-radius: 2px;
              background-color: #f7f8fc;
              margin: 0 auto;
              color: #1f2129;
            }
            .box > div {
              font-size: 14px;
            }
            .price {
              font-size: 14px;
              color: #1f2129;
              width: 99px !important;
            }
            .price_number {
              font-size: 14px;
              font-weight: 500;
              color: #1f2129;
              width: 99px !important;
            }
            .dealer {
              width: 164px !important;
              font-weight: 500;
              color: #1f2129;
            }
            .dealer :global(.dealer-btn) {
              min-width: 60px;
              height: 24px;
              line-height: 24px;
              margin-left: 4px;
              font-weight: normal;
              text-align: center;
            }

            .buttons :global(.button) {
              min-width: 48px;
              height: 24px;
              line-height: 24px;
              margin-right: 4px;
              font-weight: normal;
              border-radius: 2px;
              border: solid 0.5px #c9cbd6;
            }
            .final-price {
              margin-right: 62px;
            }
            .final-price-title {
              position: relative;
              display: flex;
              align-items: center;
            }
            .final-price-title:hover .title_tip {
              display: block;
            }
            .final-price-title .title-icon {
              line-height: 18px;
              height: 18px;
              font-size: 13px;
              margin-left: 2px;
              background-color: #ff9100;
              border-radius: 2px;
              padding: 0 4px;
              color: white;
              transform: scale(0.8);
            }
            .final-price .final-price-number {
              font-size: 14px;
              font-weight: 500;
              height: 20px;

              font-stretch: normal;
              color: #e62021;
              display: inline-block;
              text-decoration: underline;
              position: relative;
            }
            .final-price .final-price-number > span:hover {
              color: #ff9100;
              text-decoration: underline;
              cursor: pointer;
            }
            .final-price-number > span:hover .tip {
              display: block;
            }
            .popup {
              background: rgba(0, 0, 0, 0.72);
              border-radius: 4px;
              display: none;
              position: absolute;
              bottom: 50px;
              left: -150px;
              padding: 20px;
              width: 350px;
              height: 232px;
              box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.2);
            }

            .tip {
              display: none;
              z-index: 1;
              position: absolute;
              bottom: 0px;
              left: -150px;
              padding: 20px;
              width: 350px;
              height: 232px;
              border-radius: 2px;
              background: white;
              box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.2);
            }
            .tip-top {
              line-height: normal;
              margin-bottom: 20px;
            }
            .tip-top .tip-title {
              color: #1a1a1a;
              font-size: 16px;
              font-weight: 500;
              line-height: 20px;
              height: 20px;
              margin-bottom: 4px;
            }
            .tip-top .tip-title span {
              color: #ff9100;
              padding: 0 5px;
              font-size: 16px;
            }
            .tip-top span {
              line-height: 20px;
              height: 20px;
              font-size: 14px;
              color: #1a1a1a;
            }
            .tip-bottom {
              display: flex;
            }
            .tip-bottom .tip-bottom-left {
              width: 180px;
              height: 120px;
              background-image: url(${require(`static/invoice@3x.png`)});
              background-size: 100% 100%;
              margin-right: 10px;
            }
            .tip-bottom .tip-bottom-right {
              width: 120px;
              height: 120px;
              background-image: url(${require(`static/dcd-code@3x.png`)});
              background-size: 100% 100%;
            }
            .triangle {
              width: 0;
              height: 0;
              position: absolute;
              bottom: -5px;
              left: 170px;
              border-width: 6px;
              border-style: solid;
              border-color: #ffffff #fff transparent transparent;
              transform: rotate(135deg);
              box-shadow: 2px -2px 2px #d2d2d2;
            }
          `}
        </style>
      </div>
    )
  }

  return (
    yearData && (
      <section>
        <Tab
          curIndex={curIndex}
          setCurIndex={setCurIndex}
          leftContent="全部车型"
          rightContent={data.years}
          id={'carModels'}
        />
        {renderCar(yearData)}
        {yearData.length > 6 && fold ? (
          <p
            className={classnames('more', {
              'up-icon': !fold,
            })}
            onClick={() => {
              setFold(!fold)
              sendTeaCommEvent('click_series_style_more', {
                car_series_id: seriesId,
                sub_tab: data?.years[curIndex],
              })
            }}
          >
            {fold ? '查看更多' : '收起'}
            <span className="icon-arrow-ic-r" />
          </p>
        ) : null}
        <style jsx>
          {`
            section {
              width: 868px;
              margin-top: 8px;
              padding-bottom: 14px;
              background-color: #ffffff;
            }
            .more {
              width: 836px;
              height: 36px;
              margin: 2px auto;
              line-height: 36px;
              text-align: center;
              cursor: pointer;
              background-color: #f8f8f8;
            }
            .more:hover {
              color: #406599;
            }
            .icon-arrow-ic-r {
              display: inline-block;
              transform: rotate(90deg);
              vertical-align: middle;
              margin: 0 4px;
            }
            .up-icon .icon-arrow-ic-r {
              transform: rotate(-90deg);
            }
          `}
        </style>
      </section>
    )
  )
}
